export default __webpack_public_path__ + "static/media/product19_sportshoe.a8e2dc22.webp";